import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './demand_index.routes';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';

export class DemandIndexController {
    /*@ngInject*/
    constructor(SaConfigService) {
        this.saList = [];
        this.SaConfigService = SaConfigService;
    }

    $onInit() {
        this.SaConfigService.api.index((response) => {
            this.saList = response;
        });
    }
}

export default angular.module('leptonApp.demandIndex', [uiRouter, SaConfigService])
    .config(routing)
    .component('demandIndex', {
        template: require('./demand_index.html'),
        controller: DemandIndexController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand/index/demand_index.component.js